<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import {
  NXGDSModal,
  NXGDSModalSpacing,
  type NXGDSModalOffset,
} from '@nsftx/seven-nxg-design-system'
import { PdfViewer } from '@nsftx/seven-client-retail-vue-common'
import { useDocumentViewerStore } from '#src/stores/documentViewerStore'

// constants
const modalOffset: NXGDSModalOffset = {
  top: 'var(--nxgds-alias-spacing-2xl)',
  left: 'var(--nxgds-alias-spacing-2xl)',
  right: 'var(--nxgds-alias-spacing-2xl)',
  bottom: 'var(--nxgds-alias-spacing-2xl)',
}

// composables
const documentViewerStore = useDocumentViewerStore()
const { isDocumentViewerModalOpen, document: viewerDocument } = storeToRefs(documentViewerStore)

// computeds
const modalTitle = computed(() => viewerDocument.value?.title)
</script>

<template>
  <NXGDSModal
    v-model="isDocumentViewerModalOpen"
    :show-close-button="true"
    :close-on-outside-click="true"
    :title="modalTitle"
    :spacing="NXGDSModalSpacing.lg"
    :offset="modalOffset"
  >
    <div v-if="viewerDocument" class="nxg-retail-pos-document-viewer-modal__content">
      <PdfViewer
        v-if="viewerDocument.contentType === 'pdf'"
        :src="viewerDocument.src"
        :title="viewerDocument.title"
      />
    </div>
  </NXGDSModal>
</template>

<style lang="scss" scoped>
.nxg-retail-pos-document-viewer-modal__content {
  width: 100%;
  height: 100%;
}
</style>
